export default __webpack_public_path__ + "static/media/ftv.1d05ebd2.png";